module.exports = __webpack_public_path__ + "static/media/ballot.45f26dd1.svg";